<template>
  <div class="col-12 px-0">
    <div class="col-12">
      <h6
        class="text-prim-grad-1 fw-bolder text-left pb-1 border-bottom border-line-grey"
      >
        Informativa Privacy
      </h6>
      <p class="text-secondary text-justify">
        Per procedere alla registrazione è necessario
        <span
          target="_blank"
          class="point"
          @click="$bvModal.show(informativa[user.type].url)"
        >
          <u>
            leggere e prendere visione dell'informativa sul trattamento dei dati
            personali</u
          ></span
        >
      </p>
      <b-row class="text-leftmb-2">
        <!-- <b-form-checkbox
                  class="text-font-light-grey ml-0 mr-auto mx-lg-1"
                  name="data_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.data_consense"
                  :state="false"
                >
                  Non acconsento
                </b-form-checkbox> -->
        <b-form-checkbox
          class="text-font-light-grey ml-0 mr-auto mx-lg-1"
          name="data_consense"
          :value="true"
          :unchecked-value="false"
          v-model="form.data_consense"
          :state="form.data_consense == true"
        >
          Ho letto e compreso
          <span
            target="_blank"
            class="point"
            @click="$bvModal.show(informativa[user.type].url)"
          >
            <u> l'informativa privacy</u></span
          >
        </b-form-checkbox>
      </b-row>
      <b-row class="text-leftmb-2">
        <!-- <b-form-checkbox
                  class="text-font-light-grey ml-0 mr-auto mx-lg-1"
                  name="share_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.share_consense"
                  :state="false"
                >
                  Non acconsento
                </b-form-checkbox> -->
        <!-- <b-form-checkbox
                  class="text-font-light-grey ml-0 mr-auto mx-lg-1"
                  name="share_consense"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.share_consense"
                  :state="form.share_consense == true"
                >
                  Ho letto e accetto i
                  <span
                    target="_blank"
                    class="point"
                    @click="$bvModal.show(tc[user.type].url)"
                  >
                    <u> Termini e Condizioni d’uso </u></span
                  >
                </b-form-checkbox> -->
      </b-row>
    </div>
    <div class="col-12 mt-4">
      <h6
        class="text-prim-grad-1 fw-bolder text-left pb-1 border-bottom border-line-grey"
      >
        Termini e condizioni
      </h6>
      <p class="text-secondary text-justify">
        Per procedere alla registrazione è necessario
        <span
          target="_blank"
          class="point"
          @click="$bvModal.show(tc[user.type].url)"
        >
          <u
            >leggere e prendere visione dell'informativa sul termini e condizioni di
            utilizzo</u
          ></span
        >.
      </p>
      <b-row class="text-left">
        <b-form-checkbox
          class="text-font-light-grey ml-0 mr-auto mx-lg-1"
          name="share_consense"
          :value="true"
          :unchecked-value="false"
          v-model="form.share_consense"
          :state="form.share_consense == true"
        >
          Ho letto e accetto
          <span
            target="_blank"
            class="point"
            @click="$bvModal.show(tc[user.type].url)"
          >
            <u> Termini e Condizioni d’uso </u></span
          >
        </b-form-checkbox>
      </b-row>
      <b-row class="text-left">
        <!-- <b-form-checkbox
                  class="text-font-light-grey mx-1"
                  name="charge_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.charge_consense"
                  :state="false"
                >
                  Non acconsento
                </b-form-checkbox> -->
        <b-form-checkbox
          class="text-font-light-grey mx-1"
          name="charge_consense"
          :value="true"
          :unchecked-value="false"
          v-model="form.charge_consense"
          :state="form.charge_consense == true"
        >
          Ai sensi dell’articolo 1341 e ss c.c. accetto espressamente le
          previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti Termini e
          Condizioni d’uso
        </b-form-checkbox>
      </b-row>
    </div>

    <!-- <div class="col-12">
      <h6 class="
                  text-prim-grad-1
                  fw-bolder
                  text-left
                  pb-1
                  border-bottom border-line-grey
                ">
        Trattamento dati personali
      </h6>
      <p class="text-secondary text-justify">
        Per procedere alla registrazione è necessario <a target="_blank" class="text-underlined" :href="infoLinks.box1">
          <u>leggere ed
            accettare l'informativa sul trattamento dei dati personali</u></a> ed in particolare:
      </p>
      <p class="text-secondary text-justify">
        <a target="_blank" class="text-underlined" :href="infoLinks.box1"> <u>Capitolo 2 - "Finalità e base
            giuridica del trattamento", paragrafo A</u></a>
      </p>
      <b-row class="justify-content-center mb-2">
        <b-form-checkbox class="text-font-light-grey ml-0 mr-auto mx-lg-1" name="data_consense" :value="false"
          :unchecked-value="false" v-model="form.data_consense" :state="false">
          Non acconsento
        </b-form-checkbox>
        <b-form-checkbox class="text-font-light-grey ml-0 mr-auto mx-lg-1" name="data_consense" :value="true"
          :unchecked-value="false" v-model="form.data_consense" :state="form.data_consense == true">
          Ho letto e do il mio consenso
        </b-form-checkbox>
      </b-row>
      <p class="text-secondary text-justify">
        <a target="_blank" class="text-underlined" :href="infoLinks.box2"> <u>Capitolo 2 - "Finalità e base
            giuridica del trattamento", paragrafo B</u></a>
      </p>
      <b-row class="justify-content-center  mb-2">
        <b-form-checkbox class="text-font-light-grey ml-0 mr-auto mx-lg-1" name="share_consense" :value="false"
          :unchecked-value="false" v-model="form.share_consense" :state="false">
          Non acconsento
        </b-form-checkbox>
        <b-form-checkbox class="text-font-light-grey ml-0 mr-auto mx-lg-1" name="share_consense" :value="true"
          :unchecked-value="false" v-model="form.share_consense" :state="form.share_consense == true">
          Ho letto e do il mio consenso
        </b-form-checkbox>
      </b-row>
    </div>
    <div class="col-12">
      <h6 class="
                  text-prim-grad-1
                  fw-bolder
                  text-left
                  pb-1
                  border-bottom border-line-grey
                ">
        Termini e condizioni
      </h6>
      <p class="text-secondary text-justify">
        Per procedere alla registrazione è necessario <a target="_blank" class="text-underlined" :href="infoLinks.box3">
          <u>leggere ed
            accettare l'informativa sul termini e condizioni di utilizzo</u></a>.
      </p>
      <b-row class="justify-content-center">
        <b-form-checkbox class="text-font-light-grey mx-1" name="charge_consense" :value="false"
          :unchecked-value="false" v-model="form.charge_consense" :state="false">
          Non acconsento
        </b-form-checkbox>
        <b-form-checkbox class="text-font-light-grey mx-1" name="charge_consense" :value="true" :unchecked-value="false"
          v-model="form.charge_consense" :state="form.charge_consense == true">
          Acconsento
        </b-form-checkbox>
      </b-row>
    </div> -->
    <b-row class="my-2">
      <b-col>
        <b-button
          v-if="allOk"
          variant="primary primary_gradient"
          @click="sendConsenses"
        >
          <span v-if="!loading">Conferma le mie scelte</span>
          <b-spinner v-else></b-spinner>
        </b-button>
      </b-col>
    </b-row>

    <b-modal
      size="xl"
      centered
      id="info_cittadino"
      title="Informativa Privacy"
      hide-footer
    >
      <InformativaRegistrazioneCittadini></InformativaRegistrazioneCittadini>
    </b-modal>
    <b-modal
      size="xl"
      centered
      id="info_farmacista"
      title="Informativa Privacy"
      hide-footer
    >
      <InformativaRegistrazioneFarmacisti></InformativaRegistrazioneFarmacisti>
    </b-modal>
    <b-modal
      size="xl"
      centered
      id="tc_cittadino"
      title="Termini e Condizioni"
      hide-footer
    >
      <TerminiCondizioniCittadini></TerminiCondizioniCittadini>
    </b-modal>
    <b-modal
      size="xl"
      centered
      id="tc_farmacista"
      title="Termini e Condizioni"
      hide-footer
    >
      <TerminiCondizioniFarmacisti></TerminiCondizioniFarmacisti>
    </b-modal>
  </div>
</template>
<script>
import { cittadinoService } from "@/_services";
import { mapState, mapActions } from "vuex";
import InformativaRegistrazioneFarmacisti from "@/components/profile/informative/InformativaRegistrazioneFarmacisti.vue";
import InformativaRegistrazioneCittadini from "@/components/profile/informative/InformativaRegistrazioneCittadini.vue";
import TerminiCondizioniCittadini from "@/components/profile/informative/TerminiCondizioniCittadini.vue";
import TerminiCondizioniFarmacisti from "@/components/profile/informative/TerminiCondizioniFarmacisti.vue";
export default {
  name: "ConsenseComponent",
  components: {
    InformativaRegistrazioneFarmacisti,
    InformativaRegistrazioneCittadini,
    TerminiCondizioniCittadini,
    TerminiCondizioniFarmacisti,
  },
  computed: {
    allOk: function () {
      return (
        this.form.data_consense &&
        this.form.charge_consense &&
        this.form.share_consense
      );
    },
    ...mapState("utente", ["status", "user"]),
  },
  data() {
    return {
      form: {
        data_consense: false,
        charge_consense: false,
        share_consense: false,
        // notification_consense: false,
      },
      loading: false,
      infoLinks: {
        box1: process.env.VUE_APP_LINK_INFO_REGISTRAZIONE_BOX1,
        box2: process.env.VUE_APP_LINK_INFO_REGISTRAZIONE_BOX2,
        box3: process.env.VUE_APP_LINK_INFO_REGISTRAZIONE_BOX3,
      },
      informativa: {
        0: {
          text: " informativa cittadino",
          url: "info_cittadino",
        },
        1: {
          text: " informativa farmacista",
          url: "info_farmacista",
        },
      },
      tc: {
        0: {
          text: " tc cittadino",
          url: "tc_cittadino",
        },
        1: {
          text: " tc farmacista",
          url: "tc_farmacista",
        },
      },
    };
  },
  methods: {
    ...mapActions("utente", ["unMe", "me"]),
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    sendConsenses() {
      this.loading = true;
      var formData = {
        hashid: this.user.hashid,
        data: this.form,
      };
      var self = this;
      cittadinoService
        .updateUser(formData)
        .then(function (res) {
          // //console.log(res);
          self.handleUpdate();
          // localStorage.removeItem("user");
        })
        .catch(function (err) {
          //console.log("err", err);
          self.loading = false;
          self.errorAlert("Non è stato possibile memorizzare le preferenze");
          self.resetAll();
        });
    },
    handleUpdate() {
      this.me();
      var self = this;
      setTimeout(function () {
        self.loading = false;
        self.$emit("consense-ok");
      }, 7000);
    },
    resetAll() {
      this.form = {
        data_consense: false,
        charge_consense: false,
        share_consense: false,
        // notification_consense: false,
      };
    },
  },
  created() {},
};
</script>
